<template>
  <modal
    :name="'retryPaymentModal'"
    :adaptive="true"
    height="auto"
    :width="500"
    transition="linear"
    id="retryPaymentModal"
  >
    <modals-header
      :modalNameProp="$lang.messages.retryPaymentModalTitle"
      @hideModalProp="hideRetryPaymentModal"
    />

    <hr class="v--modal-hr">

    <div class="fp-modal">
      <div>{{ $lang.messages.retryPaymentModalText }}</div>
      <button
        type="button"
        class="generic-btn"
        @click="hideRetryPaymentModal"
      >
        {{ $lang.messages.retryPaymentModalBtnNo }}
      </button>
      <button
        type="button"
        class="action-btn"
        @click="retryPayment"
      >
        <span>{{ $lang.messages.retryPaymentModalBtnYes }}</span>
      </button>
    </div>
  </modal>
</template>

<script>
  import { mapActions } from "vuex";
  import modalsHeader from "@/components/common/modals/ModalsHeader";
  import { BRAINTREE_RETRY_PAYMENT } from "@/store/action.types";
  import STATUS_CODES from "@/common/statusCodes";

  export default {
    name: "RetryPaymentModal",
    components: {
      'modals-header': modalsHeader
    },
    methods: {
      ...mapActions({
        braintreeRetryPaymentAction: BRAINTREE_RETRY_PAYMENT
      }),
      /**
       * @description Show Retry payment modal
       */
      showRetryPaymentModal() {
        this.$modal.show('retryPaymentModal')
      },
      /**
       * @description Close Retry payment modal
       */
      hideRetryPaymentModal () {
        this.$modal.hide('retryPaymentModal')
      },
      /**
       * @description Emit loadSubscriptions event to parent component to refresh subscription info
       */
      loadSubscriptions(setGotIt) {
        this.$emit("loadSubscriptions", setGotIt);
      },
      /**
       * @description Retry payment on user confirm
       */
      retryPayment () {
        this.braintreeRetryPaymentAction()
          .then(() => {
            this.$snotify.success(this.$lang.messages.sn_retryPaymentSuccess, 'SUCCESS')
            this.loadSubscriptions(true)
          })
          .catch(error => {
            if (error.response.status !== 406 && error.response.data.status.code !== STATUS_CODES.FP_405 && error.response.status !== 401 && error.response.status !== 402) {
              this.$snotify.error(error.response.data.status.desc, 'ERROR')
            }
          })
          .finally(() => {
            this.hideRetryPaymentModal()
          })
      }
    }
  }
</script>
